function c(e) {
  return e.some(
    (r) => r.acceptingPreOrders === !0
  );
}
export {
  c as default
};
